export default function(API) {
	const PREFIX = API.name;

	API.log = (message, level) => {
		if(process.env.DEV_SERVER)
			switch(level)
			{
				case 'info':
					console.info(PREFIX, message);
					break;

				case 'warn':
					console.warn(PREFIX, message);
					break;

				case 'error':
					console.error(PREFIX, message);
					break;

				default:
					console.log(PREFIX, message);
					break;
			}
	}

	API.log.info = (message) => {
		API.log(message, 'info');
	}

	API.log.warning = (message) => {
		API.log(message, 'warn');
	}

	API.log.error = (message) => {
		API.log(message, 'error');
	}
}
